import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div `
  --info-dot-y: 0px;
  --info-letter-scale: 1;
  position: relative;
  display: table;
  svg {
    --icon-color: ${({ theme }) => theme.primary.background};
    path {
      &:nth-child(2) {
        transform-origin: 50% 33.75%;
        transform: translateY(var(--info-dot-y)) translateZ(0);
      }
      &:nth-child(3) {
        transform-origin: 50% 67.5%;
        transform: scaleY(var(--info-letter-scale)) translateZ(0);
      }
    }
  }
`;
export const IconInfo = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            gsap.to(wrapperRef.current, {
                keyframes: [
                    {
                        '--info-dot-y': '3px',
                        duration: 0.2,
                    },
                    {
                        '--info-dot-y': '0px',
                        duration: 0.25,
                    },
                ],
                repeat: 1,
                onComplete: triggerDone,
            });
            gsap.to(wrapperRef.current, {
                keyframes: [
                    {
                        '--info-letter-scale': '.65',
                        duration: 0.2,
                    },
                    {
                        '--info-letter-scale': '1',
                        duration: 0.25,
                    },
                ],
                repeat: 1,
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.CircleInfo, null)));
};
//# sourceMappingURL=Info.js.map